// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { ResourceType } from "../../data/talent-core/resource-type";
import { Gender } from "../../data/talent-core/gender";
import { Ethnicity } from "../../data/talent-core/ethnicity";
import { Citizenship } from "../../data/talent-core/citizenship";
import { CharacterType } from "../../data/talent-core/character-type";
import { ResourceDocument } from "./documents/resource-document";
import { ItemEnvelope } from "./base/item-envelope";

export class ResourceEnvelope extends ItemEnvelope {
	public constructor(jsonEnvelope: any) {
		super(jsonEnvelope, "Resource");
		if (jsonEnvelope) {
			this.ResourceTypes = jsonEnvelope.ResourceTypes;
			this.Genders = jsonEnvelope.Genders;
			this.Ethnicities = jsonEnvelope.Ethnicities;
			this.Citizenships = jsonEnvelope.Citizenships;
			this.CharacterTypes = jsonEnvelope.CharacterTypes;
			this.Document = jsonEnvelope.Document;
			this.CreatedOnUTC = jsonEnvelope.CreatedOnUTC;
			this.CreateUserUID = jsonEnvelope.CreateUserUID;
			this.ModifiedOnUTC = jsonEnvelope.ModifiedOnUTC;
			this.ModifyUserUID = jsonEnvelope.ModifyUserUID;
		}
	}
	public ResourceTypes: ResourceType[] = [];
	public Genders: Gender[] = [];
	public Ethnicities: Ethnicity[] = [];
	public Citizenships: Citizenship[] = [];
	public CharacterTypes: CharacterType[] = [];
	public override Document: ResourceDocument = new ResourceDocument();
	public override get ItemId(): number { return this.Document.Item.ResourceId; }
	public override get ItemName(): string { return this.Document.Person.FirstName + " " + this.Document.Person.LastName; }
}